import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-ram-2',
  imports: [],
  templateUrl: './icon-bold-ram-2.component.html',
})
export class IconBoldRam2Component {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
